import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Form } from 'react-final-form';
import { NumberInputField } from '../../../../core/components/form';
import { ExperimentConfiguration } from '../../models';

export interface ModalProps {
  size: string;
  centered: boolean;
  vertical: boolean;
  fixed: string;
  isOpen: boolean;
  toggle(): void;
  onSubmit: (values: { default_cardiac_phase_value: string }) => void;
  defaultCardiacPhaseParameters: ExperimentConfiguration[];
}

export const DefaultCardiacPhaseModal: React.FC<ModalProps> = (props: ModalProps): React.ReactElement => {
  const { size, centered, vertical, fixed, isOpen, toggle, onSubmit, defaultCardiacPhaseParameters } = props;
  const contentRef = useRef<HTMLDivElement>(null);

  let el = document.getElementById('modal-root');

  if (!el && isOpen) {
    el = document.createElement('div');
    el.id = 'modal-root';
    el.style.display = 'contents';
    el.style.position = 'relative';
    el.style.zIndex = '1050';
    document.body.classList.add('modal-open');
    document.body.appendChild(el);
  }

  useEffect(() => {
    const modal = document.getElementById('modal-root');
    if (isOpen) {
      setTimeout(() => {
        if (modal) {
          const fc = modal.firstChild as HTMLElement | null;
          fc?.classList.add('show');
          const lc = modal.lastChild as HTMLElement | null;
          lc?.classList.add('show');
        }
      }, 100);
    }

    return () => {
      if (isOpen) {
        if (modal) {
          document.body.removeChild(modal);
        }
        document.body.classList.remove('modal-open');
      }
    };
  }, [isOpen]);

  const modalClasses = `modal fade  ${fixed !== '' ? `fixed-${fixed}` : ' '}`;
  const modalStyle = isOpen ? { display: 'block' } : {};

  const dialogClasses = `modal-dialog modal-${size} ${centered ? 'modal-dialog-centered' : ''} ${
    vertical ? 'modal-dialog-vertical' : ''
  }`;

  const onHideClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();

    if (el && (e.target as HTMLElement).classList.contains('modal')) {
      (el.firstChild as HTMLElement).classList.remove('show');
      (el.lastChild as HTMLElement).classList.remove('show');
      setTimeout(() => {
        toggle();
        document.body.classList.remove('modal-open');
      }, 100);
    }
  };

  const onCloseClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (el) {
      const fc = el.firstChild as HTMLElement | null;
      fc?.classList.remove('show');
      const lc = el.lastChild as HTMLElement | null;
      lc?.classList.remove('show');
    }

    setTimeout(() => {
      toggle();
      document.body.classList.remove('modal-open');
    }, 100);
  };

  return (
    <div>
      {isOpen &&
        el &&
        ReactDOM.createPortal(
          <>
            <div role="presentation" className={modalClasses} style={modalStyle} onClick={onHideClickHandler}>
              <div className={dialogClasses} role="document">
                <div className="modal-content motion-modal isocenter-modal">
                  <span className="my-3 mx-5 isocenter-modal-title">Default cardiac Phase Options</span>
                  <Form
                    onSubmit={onSubmit}
                    render={({ handleSubmit }) => (
                      <form onSubmit={handleSubmit} className="d-flex justify-content-end students-view__actions">
                        <div className="modal-body py-0 mt-5" ref={contentRef}>
                          <div className="row mx-3">
                            <div className="col-12">
                              <NumberInputField
                                type="number"
                                selValue={parseInt(defaultCardiacPhaseParameters[0].selectedValue, 10)}
                                label="Default cardiac Phase"
                                name="default_cardiac_phase_value"
                                stepValue={1}
                                min={1}
                                max={20}
                                showTooltip
                              />
                            </div>
                          </div>

                          <div className="isocenter-buttons mt-5">
                            <button
                              type="button"
                              className="btn btn-md btn-light cancel-btn px-4"
                              aria-label="Close"
                              onClick={onCloseClickHandler}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              aria-label="Save"
                              className="btn btn-md btn-primary ms-2 simulator-btn-primary px-4"
                              onClick={() => {
                                handleSubmit();
                              }}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="modal-backdrop fade" />
          </>,
          el
        )}
    </div>
  );
};
